export const ADD_IMAGE_TO_TEXTURE = 'ADD_IMAGE_TO_TEXTURE';
export const GET_IMAGES = 'GET_IMAGES';
export const CREATE_TEXTURE = 'CREATE_TEXTURE';
export const REMOVE_TEXTURE = 'REMOVE_TEXTURE';
export const SET_ZOOM_SCALE = 'SET_ZOOM_SCALE';
export const ROTATE_IMAGE = 'ROTATE_IMAGE';
export const RESET_TRANSFORMATIONS = 'RESET_TRANSFORMATIONS';
export const REMOVE_TEXTURE_IMAGE = 'REMOVE_TEXTURE_IMAGE';
export const MOVE_IMAGE = 'MOVE_IMAGE';
export const FIT_IMAGE = 'FIT_IMAGE';
export const CHANGE_TEXTURE_ORDER = 'CHANGE_TEXTURE_ORDER';
export const FILL_IMAGE_SIZE = 'FILL_IMAGE_SIZE';
export const ADD_IMAGE_OBJECT = 'ADD_IMAGE_OBJECT';
export const DPI_RESOLUTION = 'DPI_RESOLUTION';
export const REMOVE_DPI_OVERLAY = 'REMOVE_DPI_OVERLAY';
export const ADD_DROPPED_IMAGE_TO_TEXTURE = 'ADD_DROPPED_IMAGE_TO_TEXTURE';
export const REMOVE_IMAGE_FROM_TEXTURE = 'REMOVE_IMAGE_FROM_TEXTURE';
export const REORDER_PLACEHOLDERS = 'REORDER_PLACEHOLDERS';
export const TOGGLE_DPI_OVERLAYS = 'TOGGLE_DPI_OVERLAYS';
export const LOAD_PLACEHOLDERS_BY_BOOK_ID = 'LOAD_PLACEHOLDERS_BY_BOOK_ID';
export const CHANGE_FILL_IMAGE_SIZE = 'CHANGE_FILL_IMAGE_SIZE';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/placeholders.js